module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "vue-notification-indicator"
  }, [_c('a', {
    staticClass: "indicator-handle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleVisibility($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-comment menu-glyphicon"
  }), _vm._v(" "), (_vm.hasNotifications) ? _c('span', {
    staticClass: "badge progress-bar-info"
  }, [_vm._v(_vm._s(this.items.length))]) : _vm._e()]), _vm._v(" "), (_vm.hasNotifications) ? _c('div', {
    staticClass: "dropdown-menu notification-list-container",
    style: ({
      display: _vm.listVisible ? 'block' : 'none'
    })
  }, [_c('h4', [_vm._v("Notifications")]), _vm._v(" "), (this.errorMsg.length) ? _c('div', {
    staticClass: "errorMsg bg-danger well-sm"
  }, [_vm._v("\n            " + _vm._s(this.errorMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.hasNotifications) ? _c('ul', {
    staticClass: "list-group"
  }, [_vm._l((this.items), function(i, k) {
    return [(_vm.fuzzyTimeMatch(k)) ? _c('li', [_c('h5', [_vm._v(_vm._s(_vm.fuzzyTime(i.updatedAt)))])]) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "list-group-item notification-container",
      class: {
        targeted: i.targeted
      }
    }, [(i.type === 'Standard') ? _c('NotificationStandard', {
      attrs: {
        "item": i
      },
      on: {
        "notification:deleted": _vm.deleteItem,
        "notification:targeted": _vm.toggleItemVisibility
      }
    }) : _vm._e(), _vm._v(" "), (i.type === 'ProgressErrors') ? _c('NotificationProgressErrors', {
      attrs: {
        "item": i
      },
      on: {
        "notification:deleted": _vm.deleteItem,
        "notification:targeted": _vm.toggleItemVisibility
      }
    }) : (i.type === 'PricingNoted') ? _c('NotificationPricingNoted', {
      attrs: {
        "item": i
      },
      on: {
        "notification:deleted": _vm.deleteItem,
        "notification:targeted": _vm.toggleItemVisibility
      }
    }) : (i.type === 'PricingCompleted') ? _c('NotificationPricingCompleted', {
      attrs: {
        "item": i
      },
      on: {
        "notification:deleted": _vm.deleteItem,
        "notification:targeted": _vm.toggleItemVisibility
      }
    }) : (i.type === 'PricingRejected') ? _c('NotificationPricingRejected', {
      attrs: {
        "item": i
      },
      on: {
        "notification:deleted": _vm.deleteItem,
        "notification:targeted": _vm.toggleItemVisibility
      }
    }) : _c('span', [_vm._v(_vm._s(i.title))])], 1)]
  })], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2b7466a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/Notifications.vue
// module id = 1119
// module chunks = 0